const mapping: Record<string, string> = {
  id: 't=>t.Id',
  property: 't=>t.Property',
}

export const mapSortTicketImportMappingParam = (key: string) => mapping[key]
